import {ChatService} from "@/store/services/ChatService";

export const actions = {
	...ChatService
}
